import React, { FC } from 'react';
import { Button, Container, Grid, makeStyles, Theme, Typography } from '@material-ui/core';
import Link from 'next/link';
import { Separator, SpacingLayout } from 'components/atoms';
import { LogoAboutIcon } from 'svgs';
import { animated } from 'react-spring';

interface AboutQuoteSectionProps {
  text: string;
  linkBtn: { text: string; link: string };
}

const useStyles = makeStyles((theme: Theme) => ({
  contentAbout: {
    position: 'relative',
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.primary.main,
    fontSize: 20,
    [theme.breakpoints.up('sm')]: {
      fontSize: 32,
    },
  },
  text: {
    padding: theme.spacing(3, 0),
    fontSize: 16,
    [theme.breakpoints.up('md')]: {
      fontSize: 24,
    },
    [theme.breakpoints.up('sm')]: {
      maxWidth: '100%',
    },
  },
  logo: {
    margin: theme.spacing(0, 3),
  },
  separatorWrapper: {
    width: '18%',
    [theme.breakpoints.up('md')]: {
      width: '25%',
    },
  },
  separator: {
    height: 3,
    transform: 'none',
    maxWidth: 'initial',
  },
}));

const AboutQuoteSection: FC<AboutQuoteSectionProps> = ({ text, linkBtn }) => {
  const classes = useStyles();

  return (
    <SpacingLayout className={classes.contentAbout}>
      <Container maxWidth={false} fixed>
        <Grid container spacing={8} justify={'center'}>
          <Grid item>
            <Typography className={classes.title} variant="h2" align={'center'} component={'h2'} color={'textPrimary'}>
              <animated.div className={classes.separatorWrapper} data-aos="fade-right" data-aos-delay="400">
                <Separator className={classes.separator} />
              </animated.div>
              <animated.div data-aos="zoom-in" data-aos-delay="700">
                <LogoAboutIcon className={classes.logo} />
              </animated.div>
              <animated.div className={classes.separatorWrapper} data-aos="fade-left" data-aos-delay="400">
                <Separator className={classes.separator} />
              </animated.div>
            </Typography>
            <animated.div data-aos="fade-up" data-aos-delay="400">
              <Typography className={classes.text} variant="body1" align={'center'} component={'h3'} color={'textPrimary'}>
                {text}
              </Typography>
            </animated.div>
          </Grid>
        </Grid>
        <Grid container spacing={8} justify={'center'}>
          <Grid item>
            <animated.div data-aos="fade-up" data-aos-delay="400">
              <Link href={linkBtn.link}>
                <a>
                  <Button color="primary" variant="contained">
                    {linkBtn.text}
                  </Button>
                </a>
              </Link>
            </animated.div>
          </Grid>
        </Grid>
      </Container>
    </SpacingLayout>
  );
};

export default AboutQuoteSection;
